import { render, staticRenderFns } from "./InputQuantity.vue?vue&type=template&id=2f3c95af"
import script from "./InputQuantity.vue?vue&type=script&lang=js"
export * from "./InputQuantity.vue?vue&type=script&lang=js"
import style0 from "./InputQuantity.vue?vue&type=style&index=0&id=2f3c95af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports